document.addEventListener('DOMContentLoaded', function () {
  const toggleButtons = document.querySelectorAll('.toggle-collapse');

  toggleButtons.forEach(function (toggleBtn) {
    const targetId = toggleBtn.getAttribute('data-target');
    const targetElement = document.getElementById(targetId);

    if (toggleBtn && targetElement) {
      toggleBtn.addEventListener('click', function () {
        const currentState = targetElement.getAttribute('data-collapsed');
        const isCollapsed = currentState === 'true';

        const toggleText = toggleBtn.querySelector('.toggle-text');
        const toggleIcon = toggleBtn.querySelector('.toggle-icon');

        if (isCollapsed) {
          // Expandir
          targetElement.setAttribute('data-collapsed', 'false');
          if (toggleText) toggleText.textContent = 'Ver menos';
          if (toggleIcon) toggleIcon.style.transform = 'rotate(180deg)';
        } else {
          // Colapsar
          targetElement.setAttribute('data-collapsed', 'true');
          if (toggleText) toggleText.textContent = 'Ver más';
          if (toggleIcon) toggleIcon.style.transform = 'rotate(0deg)';
        }
      });
    }
  });
});
